import { Component, OnInit,Input } from '@angular/core';
 import { MatSidenav }  from '@angular/material/sidenav';
import {MatSidenavModule} from '@angular/material/sidenav';

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss']
})
export class NavbarComponent implements OnInit {
  @Input() sidenav: MatSidenav

  constructor() { }

  ngOnInit(): void {
  }

}
